@if (data(); as drawerData) {
  <div class="engagements-drawer">
    <div class="engagements-drawer-meta">
      <div class="fw-semibold">{{ drawerData.userFullName }}</div>
      <div class="text-body-secondary">{{ drawerData.email }}</div>
    </div>

    @if (drawerData.assignments.length) {
      <div class="engagements-drawer-list">
        @for (assignment of drawerData.assignments; track assignment.clientId) {
          <div class="engagements-drawer-item">
            <div>{{ assignment.clientName }}</div>
            @if (!assignment.isActive) {
              <ap-badge
                [value]="'admin.user.engagementInactive' | translate"
                type="warning"
                size="small"
                styleClass="ap-bg-orange" />
            }
          </div>
        }
      </div>
    } @else {
      <div class="text-body-secondary">
        {{ 'admin.user.noEngagements' | translate }}
      </div>
    }
  </div>
}
